import { changePageIfAppropriate, numberOfPagesFromItems, getPagesRange } from './helpers.es.js';

var usePagination = function usePagination(_ref) {
  var currentPage = _ref.currentPage,
      isTruncated = _ref.isTruncated,
      items = _ref.items,
      itemsPerPage = _ref.itemsPerPage,
      pagesPerSlice = _ref.pagesPerSlice,
      onPageChanged = _ref.onPageChanged;

  var goToPage = function goToPage(pageNumber) {
    return changePageIfAppropriate(pageNumber, items, itemsPerPage, onPageChanged);
  };

  var numberOfPages = numberOfPagesFromItems(items, itemsPerPage);
  var shouldTruncate = isTruncated && numberOfPages > pagesPerSlice;
  var truncationOffset = shouldTruncate ? 2 : 0;

  var _pagesPerSlice = shouldTruncate ? pagesPerSlice - truncationOffset : pagesPerSlice;

  var rangeFirstPage;
  var rangeLastPage;
  var hasEndRange = false;

  if (numberOfPages <= _pagesPerSlice) {
    rangeFirstPage = 1;
    rangeLastPage = numberOfPages;
  } else {
    var pagesBeforeCurrentPage = Math.floor(_pagesPerSlice / 2);
    var pagesAfterCurrentPage = Math.ceil(_pagesPerSlice / 2) - 1;

    if (currentPage <= pagesBeforeCurrentPage) {
      rangeFirstPage = 1;
      rangeLastPage = _pagesPerSlice;
      hasEndRange = false;
    } else if (currentPage + pagesAfterCurrentPage + truncationOffset >= numberOfPages) {
      rangeFirstPage = numberOfPages - _pagesPerSlice + 1;
      rangeLastPage = numberOfPages;
      hasEndRange = true;
    } else {
      rangeFirstPage = currentPage - pagesBeforeCurrentPage;
      rangeLastPage = currentPage + pagesAfterCurrentPage;
    }
  }

  var pagesRange = getPagesRange(rangeFirstPage, rangeLastPage);
  var startRange = hasEndRange ? [1] : pagesRange;
  var endRange = hasEndRange ? pagesRange : [numberOfPages];
  return {
    numberOfPages: numberOfPages,
    pagesRange: pagesRange,
    shouldTruncate: shouldTruncate,
    startRange: startRange,
    endRange: endRange,
    goToPage: goToPage
  };
};

export { usePagination as default };